<div class="modal-header">
  <h5 class="modal-title">{{ title }}</h5>
  <button type="button" class="close" aria-label="Close" (click)="onClose()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>Type <span class="text-danger">*</span></label>
          <select class="form-control" formControlName="type">
            <option *ngFor="let t of types" [value]="t.value">{{ t.label }}</option>
          </select>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Libellé <span class="text-danger">*</span></label>
          <input type="text" class="form-control" formControlName="libelle" placeholder="Libellé de la facture">
          <span *ngIf="submit && f.libelle.errors?.required" class="text-danger">Le libellé est obligatoire</span>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Montant total <span class="text-danger">*</span></label>
          <input type="number" class="form-control" formControlName="montantTotal">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Montant payé</label>
          <input type="number" class="form-control" formControlName="montantPaye">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Statut</label>
          <select class="form-control" formControlName="statut">
            <option *ngFor="let s of statuts" [value]="s.value">{{ s.label }}</option>
          </select>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Catégorie</label>
          <select class="form-control" formControlName="categorie">
            <option value="">Sélectionner</option>
            <option *ngFor="let c of categories" [value]="c.value">{{ c.label }}</option>
          </select>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Date d'émission</label>
          <input type="date" class="form-control" formControlName="dateEmission">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Date d'échéance</label>
          <input type="date" class="form-control" formControlName="dateEcheance">
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label>Description</label>
          <textarea class="form-control" formControlName="description" rows="2"></textarea>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="onClose()">Fermer</button>
  <button type="button" class="btn btn-primary" [disabled]="form.invalid" (click)="onSubmit()">Enregistrer</button>
</div>
